
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import TripSheet from "../components/tripsheet";
import Footer from "../components/footer";

function TripSheetPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <TripSheet /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default TripSheetPage;
